import React from 'react';
import PropTypes from 'prop-types';
import { Image, Icon } from 'semantic-ui-react';
import styles from '../Playlist.scss';

const RecommendationThumbnail = ({
  onClick,
  playlist,
  action,
  actionClassName,
  actionIcon
}) =>
  <div className={styles.recommendation}>
    {action !== null &&
      <Image
        src={actionIcon}
        className={actionClassName}
        onClick={e => {
          e.stopPropagation();
          action(playlist.id);
        }}
      />}
    {(() => {
      const { thumbnail } = playlist;
      return (
        <div
          className={styles.playlistThumbnail}
          onClick={e => { if (onClick) onClick(e); }}
        >
          {!thumbnail && <Icon name='music' />}
          {thumbnail && <Image src={thumbnail.url} />}
        </div>
      );
    })()}
    <p className={styles.recommendationTitle} title={playlist.title}>
      <strong>
        {playlist.title}
      </strong>
    </p>
  </div>;

RecommendationThumbnail.propTypes = {
  onClick: PropTypes.func,
  playlist: PropTypes.object.isRequired,
  action: PropTypes.func,
  actionIcon: PropTypes.string,
  actionClassName: PropTypes.string
};

export default RecommendationThumbnail;



// WEBPACK FOOTER //
// ./webpack/components/Playlist/Recommendation/Thumbnail.js